import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children, settings }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a href='#main' className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-sun focus:px-4 focus:py-2 focus:font-bold'>
                Skip to content
            </a>

            <Header />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer settings={settings} />
        </div>
    )
}
